const canUseStorage = () => typeof window !== "undefined" && Boolean(window.localStorage);

export const loadBrowserCache = (storageKey, maxAgeMs) => {
  if (!canUseStorage()) {
    return null;
  }
  try {
    const rawValue = window.localStorage.getItem(storageKey);
    if (!rawValue) {
      return null;
    }
    const parsed = JSON.parse(rawValue);
    if (!parsed?.savedAt || typeof parsed.savedAt !== "number") {
      return null;
    }
    if (Date.now() - parsed.savedAt > maxAgeMs) {
      return null;
    }
    return parsed.data ?? null;
  } catch {
    return null;
  }
};

export const saveBrowserCache = (storageKey, data) => {
  if (!canUseStorage()) {
    return;
  }
  try {
    window.localStorage.setItem(storageKey, JSON.stringify({ savedAt: Date.now(), data }));
  } catch {
    // no-op
  }
};